/* eslint-disable @typescript-eslint/no-unsafe-return */
import {isRejectedWithValue} from '@reduxjs/toolkit';
import type {Middleware} from '@reduxjs/toolkit';
import {toast} from 'react-toastify';
import {history} from 'browserhistory';

/**
 * "If the action is rejected, log the action to the console."
 *
 * Now, let's add this to our store:
 * @returns A function that returns a function that returns a function that returns the result of
 * calling `next` with the action.
 */
export const rtkQueryErrorLogger: Middleware = () => next => action => {
	if (isRejectedWithValue(action)) {
		const customId = 'custom-id-yes';

		if (action.meta.arg.endpointName !== 'getReMapSetView') {
			toast.error(action.payload.data || action.payload.error, {
				toastId: customId,
			});
		}
		if (
			action.payload.originalStatus === 401 ||
			action.payload.originalStatus === 403
		) {
			history.push('/notAuthorize');
		}
	}

	return next(action);
};
